import * as React from 'react';
import { ArticleHeading1, ArticleHeading3, Body1, Image, useDeviceType } from '@cian/ui-kit';

import { Wrapper } from '../Wrapper';
import { IFrequentlyAskedQuestionSchema } from '../../repositories/legal-check/entities/questions/FrequentlyAskedQuestionSchema';

import * as styles from './styles.css';

export interface IQuestionsProps {
  questions: IFrequentlyAskedQuestionSchema[];
}

export const Questions: React.FC<IQuestionsProps> = ({ questions }) => {
  const isDesktop = useDeviceType() === 'desktop';
  const imgSize = isDesktop ? 64 : 40;

  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['title']}>
          <ArticleHeading1>Часто задаваемые вопросы</ArticleHeading1>
        </div>
        <div className={styles['questions']}>
          {questions.map((item, index) => {
            return (
              <div key={index} className={styles['questions-block']}>
                <div className={styles['question']}>
                  <Image src={item.question.imgUrl} width={imgSize} height={imgSize} borderRadius="50%" />
                  <div className={styles['text']}>
                    <ArticleHeading3>{item.question.text}</ArticleHeading3>
                  </div>
                </div>
                <div className={styles['answer']}>
                  <Image src={item.answer.imgUrl} width={imgSize} height={imgSize} borderRadius="50%" />
                  <div className={styles['text']}>
                    <Body1>{item.answer.text}</Body1>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Wrapper>
    </div>
  );
};

Questions.displayName = 'Questions';
